import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Only apply filters in development mode
if (import.meta.env.DEV) {
  const SILENCED_PATTERNS = [
    /GSAP target.*not found/,
    /WebSocket connection failed/,
    /WebSocket connection to.*failed/,
    /API Error.*payments/,
    /Failed to fetch.*payments/,
    /socket\.io.*websocket/,
    /download the React DevTools/,
  ];

  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalError = console.error;

  console.log = (...args) => {
    const message = args.join(" ");
    if (!SILENCED_PATTERNS.some((pattern) => pattern.test(message))) {
      originalLog(...args);
    }
  };

  console.warn = (...args) => {
    const message = args.join(" ");
    if (!SILENCED_PATTERNS.some((pattern) => pattern.test(message))) {
      originalWarn(...args);
    }
  };

  console.error = (...args) => {
    const message = args.join(" ");
    if (!SILENCED_PATTERNS.some((pattern) => pattern.test(message))) {
      originalError(...args);
    }
  };
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
